import { render } from "./ConfirmsPassword.vue?vue&type=template&id=033bd0b9"
import script from "./ConfirmsPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmsPassword.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/ConfirmsPassword.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "033bd0b9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('033bd0b9', __exports__)) {
    api.reload('033bd0b9', __exports__)
  }
  
  module.hot.accept("./ConfirmsPassword.vue?vue&type=template&id=033bd0b9", () => {
    api.rerender('033bd0b9', render)
  })

}


export default __exports__